import {
  useBlockProps,
  useInnerBlocksProps,
  InnerBlocks,
} from '@wordpress/block-editor';
import {
  InspectorControlsAppearance,
  InspectorControlsGeneral,
  InspectorTabs,
} from '@components/inspector-tabs';
import Visibility from '@components/visibility';
import Label from '@components/block-label';
import {
  FocusableIcon,
  FocusableIconSwitcher,
} from '@components/focusable-block-icon';
import { title } from './block.json';
import classnames from 'classnames';

const Edit = (props) => {
  const { attributes, setAttributes } = props;
  const { label, blockVisibility, enableFocusableIcon } = attributes;

  const blockProps = useBlockProps({
    className: classnames({
      'swiper-slide': true,
      disable: !blockVisibility,
      'has-focusable-icon': enableFocusableIcon,
    }),
  });

  const { children, ...innerBlockProps } = useInnerBlocksProps(blockProps, {
    templateLock: false,
    template: [
      [
        'core/paragraph',
        {
          placeholder: 'Slider content ...',
        },
      ],
    ],
    renderAppender: () => <InnerBlocks.ButtonBlockAppender />,
  });

  return (
    <>
      <InspectorTabs>
        <InspectorControlsGeneral>
          <Label {...{ label, setAttributes }} />
          <Visibility {...{ blockVisibility, setAttributes }} />
        </InspectorControlsGeneral>
        <InspectorControlsAppearance>
          <FocusableIconSwitcher
            {...{
              enableFocusableIcon,
              setAttributes,
            }}
          />
        </InspectorControlsAppearance>
      </InspectorTabs>
      <div {...innerBlockProps}>
        {enableFocusableIcon && (
          <FocusableIcon {...{ title, attributes, setAttributes }} />
        )}
        {children}
      </div>
    </>
  );
};

export default Edit;
